import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import AutenticacaoService from "../../services/AutenticacaoService";
import { ActionCreators } from "../../_actions/ActionCreators";
import {
  BtnAreaLogadaContainer,
  BtnUserNameStyle,
  BurguerButtonStyle,
  HeaderLinksStyle,
  HeaderStyle,
  LinkUserArea,
  RegisterMobile,
} from "./style";
import Logo from "./Logo";

const usuario = new AutenticacaoService();

function Header(props) {
  const userName = useSelector((state) => state.user);
  const closeModal = useSelector((state) => state.headerClicked);
  const [open, setOpen] = useState(false);
  let location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const topElement = document.getElementById("top");
    if (topElement) {
      topElement.scrollIntoView();
    }
    if (!closeModal) {
      setOpen(false);
    }
  }, [closeModal]);

  const sair = () => {
    usuario.logout(() => {
      window.location = "/";
    });
  };

  const onClick = () => {
    setOpen(!open);
    dispatch(ActionCreators.isHeaderSubMenuClicked(true));
  };

  return (
    <>
      {location.pathname === "/perfil" || location.pathname.includes("rastreio") ? (
        <></>
      ) : (
        <HeaderStyle open={open}>
          <div id="top" className="header-container">
            <div className="header-top">
              <Logo isLogged={props.isLogged} />

              {props.isLogged === false ? (
                <RegisterMobile>
                  <Link open={open} className="header-link mobile register" to="/register">
                    Cadastre-se
                  </Link>
                </RegisterMobile>
              ) : (
                ""
              )}
              {props.isLogged === false ? (
                <>
                  <BurguerButtonStyle onClick={onClick}>
                    {open ? (
                      <ion-icon name="close-outline"></ion-icon>
                    ) : (
                      <ion-icon name="menu-outline"></ion-icon>
                    )}
                  </BurguerButtonStyle>

                  <HeaderLinksStyle open={open} logged={props.isLogged}>
                    <Link onClick={onClick} className="header-link mobile" to="/login">
                      Login
                    </Link>
                    <a
                      className="header-link space"
                      href="https://suporte.flexfrete.com.br"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suporte
                    </a>

                    <LinkUserArea
                      to="/login"
                      className="button is-rounded button-landing btn-branco"
                    >
                      Minha Conta
                    </LinkUserArea>
                    <LinkUserArea
                      to="/register"
                      onClick={onClick}
                      open={open}
                      className="button is-rounded"
                      style={{ textTransform: "uppercase" }}
                    >
                      Cadastre-se
                    </LinkUserArea>
                  </HeaderLinksStyle>
                </>
              ) : (
                <>
                  <div className="mobile-container">
                    <BurguerButtonStyle onClick={onClick}>
                      {open ? (
                        <ion-icon name="close-outline"></ion-icon>
                      ) : (
                        <ion-icon name="menu-outline"></ion-icon>
                      )}
                    </BurguerButtonStyle>

                    <HeaderLinksStyle open={open} logged={props.isLogged}>
                      <a
                        className="header-link suporte space"
                        href="/"
                        style={{
                          fontSize: "1.8em",
                          paddingLeft: "0px",
                          paddingTop: "0px",
                          marginTop: "0px",
                        }}
                      >
                        Olá, {userName.name}
                      </a>
                      <a
                        className="header-link suporte space"
                        href="https://suporte.flexfrete.com.br"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Suporte
                      </a>
                      <Link onClick={sair} className="header-link mobile" to="/login">
                        Desconectar
                      </Link>
                    </HeaderLinksStyle>
                  </div>

                  <BtnAreaLogadaContainer>
                    <div className="desktop-container">
                      <div className="supportLink">
                        <a
                          className="header-link suporte-logado space"
                          href="https://suporte.flexfrete.com.br"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Suporte
                        </a>
                      </div>
                      <BtnUserNameStyle onClick={onClick} open={open}>
                        <p className="header-username">
                          Olá, {userName.name}
                          {open ? (
                            <ion-icon name="caret-up-outline"></ion-icon>
                          ) : (
                            <ion-icon name="caret-down-outline"></ion-icon>
                          )}
                        </p>

                        <p className="user-exit-link" onClick={sair}>
                          <Link to="/logout">
                            Sair <ion-icon name="exit-outline"></ion-icon>
                          </Link>
                        </p>
                      </BtnUserNameStyle>
                    </div>
                  </BtnAreaLogadaContainer>
                </>
              )}
            </div>
          </div>
        </HeaderStyle>
      )}
      {}
    </>
  );
}

export default Header;
